/**
 * API Services Index
 *
 * Central export point for all API services.
 * Import services from this file in your components:
 *
 * @example
 * import { authApi, tenantsApi, propertiesApi } from '../../services/api';
 *
 * // Use in component
 * const response = await tenantsApi.getAll(landlordId);
 */

// Base client and utilities
export { default as apiClient, getLandlordId, getUserEmail, getUserData } from './client';

// Authentication
export { authApi, skyAuthApi } from './auth';

// Properties
export { propertiesApi } from './properties';

// Tenants
export { tenantsApi } from './tenants';

// Payments & Billing
export { paymentsApi } from './payments';

// Card Payments (Paystack)
export { default as cardPaymentsApi } from './cardPayments';

// Messages & Mail
export { messagesApi, mailApi } from './messages';

// Dashboard & Analytics
export { dashboardApi, analyticsApi } from './dashboard';

// Files & Uploads
export { filesApi } from './files';

// Expenses
export { expensesApi } from './expenses';

// Events
export { eventsApi } from './events';

// Transactions
export { transactionsApi } from './transactions';

// Reports
export { reportsApi } from './reports';

// User Management
export { userManagementApi } from './userManagement';

// Tickets & Issues
export { ticketsApi, problemTypesApi, serviceProvidersApi } from './tickets';

// Legal Compliance
export { legalComplianceApi } from './legalCompliance';

// Permissions
export { permissionsApi } from './permissions';

// Payouts
export { payoutsApi } from './payouts';

// Notifications
export { notificationsApi } from './notifications';

// Accounting
export { accountingApi } from './accounting';

/**
 * Default export - all APIs in one object
 */
export default {
    auth: require('./auth').authApi,
    skyAuth: require('./auth').skyAuthApi,
    properties: require('./properties').propertiesApi,
    tenants: require('./tenants').tenantsApi,
    payments: require('./payments').paymentsApi,
    cardPayments: require('./cardPayments').default,
    messages: require('./messages').messagesApi,
    mail: require('./messages').mailApi,
    dashboard: require('./dashboard').dashboardApi,
    analytics: require('./dashboard').analyticsApi,
    files: require('./files').filesApi,
    expenses: require('./expenses').expensesApi,
    events: require('./events').eventsApi,
    transactions: require('./transactions').transactionsApi,
    reports: require('./reports').reportsApi,
    userManagement: require('./userManagement').userManagementApi,
    tickets: require('./tickets').ticketsApi,
    problemTypes: require('./tickets').problemTypesApi,
    serviceProviders: require('./tickets').serviceProvidersApi,
    legalCompliance: require('./legalCompliance').legalComplianceApi,
    permissions: require('./permissions').permissionsApi,
    payouts: require('./payouts').payoutsApi,
    notifications: require('./notifications').notificationsApi,
    accounting: require('./accounting').accountingApi,
};
